/**
 * Normalizes the inconsistent response envelope across microservices.
 * Paginated and some single-resource endpoints wrap the payload in `{data}`,
 * while others (e.g. permission `account-users/{id}/roles`, account-user
 * `accounts/{id}/users/{userId}`) return the resource body directly.
 * Returns the inner body regardless of which shape the service used.
 */
export const getResponseBody = <T>(response: unknown): T => {
    const wrapped = response as {data?: unknown} | null | undefined;
    return ((wrapped?.data ?? wrapped) ?? null) as T;
};
